import { CalendarSearch, RefreshCw } from "lucide-react"

import { Button } from "@/components/button"
import { EmptyState } from "@/components/shared/empty-state"
import { Card, CardContent } from "@/components/ui/card"
import { SkeletonTable } from "@/components/ui/skeleton"

export function RosterLoadingState() {
  return (
    <Card role="status" aria-live="polite" aria-label="Loading roster data">
      <CardContent className="p-0">
        <SkeletonTable rows={10} columns={6} />
      </CardContent>
    </Card>
  )
}

export function RosterErrorState({
  selectedRosterDate,
  onRetry,
  onClearDate,
}: {
  selectedRosterDate: string
  onRetry: () => void
  onClearDate: () => void
}) {
  return (
    <Card role="alert" aria-live="assertive">
      <CardContent className="py-10">
        <EmptyState
          icon={<CalendarSearch className="size-5" />}
          tone="danger"
          title="Failed to load published roster"
          description={
            selectedRosterDate
              ? "Could not load the roster for the selected date. Retry or pick a different date."
              : "Use the war date picker above to load a published roster for that week."
          }
          actions={
            <>
              <Button variant="outline" onClick={onRetry}>
                <RefreshCw className="size-4" />
                Retry
              </Button>
              {selectedRosterDate ? (
                <Button variant="outline" onClick={onClearDate}>
                  Clear date
                </Button>
              ) : null}
            </>
          }
        />
      </CardContent>
    </Card>
  )
}

export function RosterEmptyState() {
  return (
    <Card>
      <CardContent className="py-10">
        <EmptyState
          icon={<CalendarSearch className="size-5" />}
          title="Choose a war date to view a published roster"
          description="Select a date above to load the member-facing published snapshot for that guild war cycle."
        />
      </CardContent>
    </Card>
  )
}
